exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-recipes-js": () => import("./../../../src/pages/recipes.js" /* webpackChunkName: "component---src-pages-recipes-js" */),
  "component---src-pages-taxis-js": () => import("./../../../src/pages/taxis.js" /* webpackChunkName: "component---src-pages-taxis-js" */),
  "component---src-pages-valorant-js": () => import("./../../../src/pages/valorant.js" /* webpackChunkName: "component---src-pages-valorant-js" */)
}

